<template>
  <form v-if="relacionamento" role="form" @submit.stop.prevent="onSubmit">
    <vs-card>
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <b>Assunto: </b> {{ relacionamento.assunto }}<br />
          <b>Tipo de Solicitação: </b>
          {{ relacionamento.tipoSolicitacao.tipoRelacionamento }}<br />
          <b>Aberto pelo setor: </b>{{ relacionamento.setor.nomeSetor }}<br />
          <b>Status Atual: </b
          >{{ relacionamento.statusRelacionamento.statusRelacionamento }}<br />
          <div v-if="dadosVeiculo">
            <b>Placa do Veículo: </b> {{ dadosVeiculo.placa }}<br />
          </div>
        </div>
      </div>
    </vs-card>
    <vs-card>
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-input
            class="w-full"
            label="Solicitante"
            name="solicitante"
            v-model="form.solicitante"
            v-validate="{ required: true, min: 8 }"
            :state="validateState('solicitante')"
            :danger="validateClass('solicitante')"
            val-icon-danger="clear"
            danger-text="Informe o nome completo de quem solicita este atendimento"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <!--vs-select
            class="select-large w-full"
            name="status do atendimento"
            label="Status do atendimento"
            v-model="form.idStatus"
            v-validate="{ required: true }"
            :state="validateState('status do atendimento')"
            :danger="validateClass('status do atendimento')"
            danger-text="Selecione o status do atendimento"
          >
            <vs-select-item
              :key="index"
              :value="item.idStatusRelacionamento"
              :text="item.statusRelacionamento"
              v-for="(item, index) in statusRelacionamento"
            />
          </vs-select-->
          <label for="" class="vs-select--label">Status do Atendimento</label>
          <v-select
            :options="statusRelacionamento"
            name="Status do Atendimento"
            id="Status do Atendimento"
            v-model="form.idStatus"
            label="statusRelacionamento"
            class="select-large w-full"
            :reduce="(item) => item.idStatusRelacionamento"
            v-validate="{ required: true }"
            :state="validateState('Status do Atendimento')"
            :danger="validateClass('Status do Atendimento')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mt-2 mb-2">
          <label for="" class="vs-select--label">Descrição</label>
          <vs-textarea
            v-model="form.descricaoAtendimento"
            name="descricao da solicitacao"
            v-validate="{ required: true, min: 20 }"
            :state="validateState('descricao da solicitacao')"
            :danger="validateClass('descricao da solicitacao')"
            danger-text="Descreva a solicitação"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-center">
          <vs-button color="success" type="gradient">Salvar</vs-button>
        </div>
      </div>
    </vs-card>
  </form>
</template>
<script>
import service from "./../../services";
import locale from "./../../locale";
import vSelect from "vue-select";
export default {
  props: ["relacionamento", "statusRelacionamento", "dadosVeiculo"],
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      placa: null,
      form: {
        solicitante: null,
        idStatus: null,
        descricaoAtendimento: null,
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    resetForm() {
      this.form = {
        solicitante: null,
        idStatus: null,
        descricaoAtendimento: null,
      };
    },
    onSubmit() {
      const { idRelacionamento, idAssociado } = this.relacionamento;
      const dadosAtualizacaoRelacionamento = {
        ...this.form,
        idRelacionamento,
        idAssociado,
      };

      this.$validator.validateAll().then((isValid) => {
        if (!isValid) return;
        this.$vs.loading();
        service
          .post(
            "Relacionamento",
            "inserirRegistroAtendimento",
            dadosAtualizacaoRelacionamento
          )
          .then((res) => {
            console.log("155, response", res);
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Atendimento registrado com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.$emit("concluido");
            this.resetForm();
          })
          .catch((error) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: error,
              color: "danger",
            });
          });
      });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
  },
};
</script>
<style></style>
